import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { queries } from "@erp/shared/queries";
import { approvalApi } from "@erp/shared/api/generated/wrappers/approval";
export function useApprovalLine({ documentType, documentId, enabled = true, }) {
    const docType = computed(() => typeof documentType === "string" ? documentType : documentType.value);
    const docId = computed(() => {
        const val = typeof documentId === "number" || documentId === null
            ? documentId
            : documentId.value;
        return val;
    });
    const isEnabled = computed(() => {
        const e = typeof enabled === "boolean" ? enabled : enabled.value;
        return e && docId.value !== null && docId.value > 0;
    });
    const { data: steps, isFetched, refetch } = useQuery({
        queryKey: computed(() => queries.approval.line(docType.value, docId.value ?? 0).queryKey),
        queryFn: () => approvalApi.getApprovalLine(docType.value, docId.value ?? 0),
        enabled: isEnabled,
    });
    const approvalSteps = computed(() => steps.value ?? []);
    return {
        steps: approvalSteps,
        isFetched,
        refetch,
    };
}
